import { connect } from "react-redux"
import FlagAndRegionName from "QuorumGrassroots/widgets/FlagAndRegionName/components/index"

export default connect(null, null)(FlagAndRegionName)
